export enum CardValue {
    ClubAce = 101,
    ClubTwo = 102,
    ClubThree = 103,
    ClubFour = 104,
    ClubFive = 105,
    ClubSix = 106,
    ClubSeven = 107,
    ClubEight = 108,
    ClubNine = 109,
    ClubTen = 110,
    ClubJack = 111,
    ClubQueen = 112,
    ClubKing = 113,

    DiamondAce = 201,
    DiamondTwo = 202,
    DiamondThree = 203,
    DiamondFour = 204,
    DiamondFive = 205,
    DiamondSix = 206,
    DiamondSeven = 207,
    DiamondEight = 208,
    DiamondNine = 209,
    DiamondTen = 210,
    DiamondJack = 211,
    DiamondQueen = 212,
    DiamondKing = 213,

    HeartAce = 301,
    HeartTwo = 302,
    HeartThree = 303,
    HeartFour = 304,
    HeartFive = 305,
    HeartSix = 306,
    HeartSeven = 307,
    HeartEight = 308,
    HeartNine = 309,
    HeartTen = 310,
    HeartJack = 311,
    HeartQueen = 312,
    HeartKing = 313,

    SpadeAce = 401,
    SpadeTwo = 402,
    SpadeThree = 403,
    SpadeFour = 404,
    SpadeFive = 405,
    SpadeSix = 406,
    SpadeSeven = 407,
    SpadeEight = 408,
    SpadeNine = 409,
    SpadeTen = 410,
    SpadeJack = 411,
    SpadeQueen = 412,
    SpadeKing = 413,

    Unknown = 0
}
